import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/system';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { RouterProvider } from 'react-router';
import './App.css';
import { EmployerInfo } from './consts/types/employer';
import { UserType } from './consts/types/general';
import { UserInfo } from './consts/types/user';
import { db } from './firebase';
import store from './reducers';
import { authActionsCreators } from './reducers/auth';
import { employerActionsCreators } from './reducers/employer';
import { userActionsCreators } from './reducers/user';
import { router } from './routes';
const { NotificationContainer } = require('react-notifications');

const auth = getAuth();
onAuthStateChanged(auth, async (user) => {
  const url = window.location.pathname;
  if (user && user.email) {
    const docRef = doc(db, url.includes("employer") ? "employers" : "users", user.email);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      if (url.includes("employer")) {
        store.dispatch(authActionsCreators.setUserType({
          type: UserType.Employer
        }));
        store.dispatch(employerActionsCreators.setEmployer({
          employer: { ...docSnap.data() as EmployerInfo, }
        }));
      }
      else {
        store.dispatch(authActionsCreators.setUserType({
          type: UserType.User
        }));
        store.dispatch(userActionsCreators.setUser({
          user: { ...docSnap.data() as UserInfo, }
        }));
      }
    }
    else {
      if (url.includes("employer")) {
        store.dispatch(employerActionsCreators.setEmployer({ employer: null }));
      }
      else {
        store.dispatch(userActionsCreators.setUser({ user: null }));
      }
    }
  }
  else {
    store.dispatch(userActionsCreators.setUser({ user: null }));
    setTimeout(() => {
      store.dispatch(employerActionsCreators.setEmployer({ employer: null }));
    }, 0);
  }
  store.dispatch(userActionsCreators.setAuthenticating({ authenticating: false }));
});


const theme = createTheme({
  typography: {
    fontFamily: `"Montserrat","Roboto","Helvetica","Arial",sans-serif`
  }

  // direction: 'rtl', // Both here and <body dir="rtl">
});
// Create rtl cache
// const cacheRtl = createCache({
//   key: 'muirtl',
//   stylisPlugins: [rtlPlugin],
// });
function App() {
  return (
    // <CacheProvider value={cacheRtl}>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Box >
          <RouterProvider router={router} />
          <NotificationContainer />
        </Box>
      </LocalizationProvider>
    </ThemeProvider>
    // </CacheProvider>
  );
}

export default App;
